export default "__VITE_ASSET__CLgl470D__"